import type {ITimeoutService, IWindowService} from 'angular';

/**
 * @ngdoc service
 * @name reloader
 * @module portaro.services
 *
 * @description
 * Factory provides reloading features
 */
export default class ReloaderService {
    public static serviceName = 'reloader';

    /*@ngInject*/
    constructor(private $window: IWindowService, private $timeout: ITimeoutService) {
    }

    /**
     * @ngdoc method
     * @name reloader#reload
     *
     * @description
     * Reloads page
     */
    public reload(timeout?: number) {
        if (angular.isDefined(timeout)) {
            this.$timeout(() => this.$window.location.reload(), timeout);
        } else {
            this.$window.location.reload();
        }
    }
}
